import React from "react";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import ArrowLeftIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ArrowLeftIconPath";
import FullScreenPopup from "../../../layout/components/FullScreenPopup/FullScreenPopup";
import { SimpleHeader } from "../../../layout/components/SimpleHeader/SimpleHeader";
import { useTranslation } from "@coworker/locales";
import { FixaText } from "../../../shared/wrappers/FixaText/FixaText";
import { useMsal } from "@azure/msal-react";
import styles from "./error.module.css";

interface ErrorProps {
  isAccessIssue: boolean;
}

export const Error: React.FC<ErrorProps> = ({ isAccessIssue }) => {
  const { t } = useTranslation();
  const { instance } = useMsal();
  const handleBackToLoginClick = async () => {
    await instance.logoutRedirect();
  };

  return (
    <FullScreenPopup noPadding noAppBar>
      <SimpleHeader displayAllScreens></SimpleHeader>
      <div className={styles["error-container"]}>
        <FixaButton
          size="small"
          type="secondary"
          onClick={() => handleBackToLoginClick()}
          text={t("backToLoginString")}
          iconPosition="leading"
          ssrIcon={ArrowLeftIconPath}
        />
        <FixaText
          tagName="h2"
          textStyle="Heading.S"
          className={styles["error-message"] || ""}
        >
          {isAccessIssue ? t("noAccessMessageString") : t("loginFailureString")}
        </FixaText>
        <FixaText tagName="p" textStyle="Body.S">
          {isAccessIssue
            ? t("noAccessDescriptionString")
            : t("loginFailureDescriptionString")}
        </FixaText>
      </div>
    </FullScreenPopup>
  );
};
